import { createFileRoute } from "@tanstack/react-router"
import { ScheduleHistory } from "../components/settings/schedule-history"
import { useScheduledJobRevisions } from "../services/use-scheduled-jobs"
function HistoryPage() {
  const { jobId } = Route.useParams()
  const revisions = useScheduledJobRevisions(jobId)
  return (
    <ScheduleHistory
      revisions={revisions.data ?? []}
      isLoading={revisions.isLoading}
      error={revisions.error}
    />
  )
}
export const Route = createFileRoute("/settings/schedules/$jobId/history")({
  component: HistoryPage,
})
